import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=1ecd471f&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=1ecd471f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd471f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecd471f')) {
      api.createRecord('1ecd471f', component.options)
    } else {
      api.reload('1ecd471f', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=1ecd471f&scoped=true", function () {
      api.rerender('1ecd471f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Login.vue"
export default component.exports